import React from 'react';
import clsx from 'clsx';
import FavoriteProposalsHeader from 'components/favorite-proposals/FavoriteProposalsHeader';
import FavoriteProposalsTable from 'components/favorite-proposals/FavoriteProposalsTable';
import FiltersPanel from 'components/favorite-proposals/FiltersPanel';
import { createStyles } from '../../globalStyles';

const FavoriteProposalsPage = (): JSX.Element => {
  const classes = createStyles();
  return (
    <div className={clsx(classes.pageWrapper, classes.simplePageWrapper)}>
      <FavoriteProposalsHeader />
      <FiltersPanel />
      <FavoriteProposalsTable />
    </div>
  );
};

export default FavoriteProposalsPage;
